var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamBg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 697,
    viewBox: "0 0 257 697",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M115.784 565.247C209.34 457.97 256.186 335.022 256.333 196.418C256.48 57.8145 178.093 -7.23413 21.1886 1.28035C-135.722 9.79664 -268.781 52.4968 -377.995 129.383C-487.208 206.269 -535.584 312.822 -523.129 449.044C-510.674 585.266 -424.462 665.508 -264.501 689.772C-104.534 714.033 22.2275 672.523 115.784 565.247Z",
    fill: "#337E84"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamBg1);
export default __webpack_public_path__ + "static/media/team_bg_1.67f7f4999d677892b1bcb0500a670116.svg";
export { ForwardRef as ReactComponent };